import React from "react";
import { CheckSquare } from "lucide-react";

const SAMPLES = [
  "Student achievements are regularly displayed throughout the school.",
  "Important school events are consistently promoted through visual displays.",
  "Student work is regularly displayed throughout the building.",
  "Athletic events are promoted effectively.",
  "Teachers can quickly create visual materials when needed.",
  "Staff have easy access to tools for creating posters, banners, and displays.",
];

export default function VCSampleQuestions() {
  return (
    <section
      data-testid="vc-samples-section"
      className="bg-white py-24 md:py-32 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-12 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            Sample assessment questions
          </div>
          <h2
            data-testid="vc-samples-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
          >
            A Few of the Questions You'll Answer
          </h2>
        </div>

        <ul
          data-testid="vc-samples-list"
          className="max-w-3xl space-y-3"
        >
          {SAMPLES.map((q, i) => (
            <li
              key={q}
              data-testid={`vc-sample-${i}`}
              className="flex items-start gap-4 bg-[#F4F6F4] border border-slate-200 rounded-xl p-5"
            >
              <span className="flex-shrink-0 mt-0.5 w-7 h-7 rounded-md bg-teal/10 border border-teal/30 flex items-center justify-center">
                <CheckSquare className="w-4 h-4 text-teal" strokeWidth={2.5} />
              </span>
              <span className="text-base text-navy font-medium leading-snug">
                {q}
              </span>
            </li>
          ))}
        </ul>

        <p
          data-testid="vc-samples-note"
          className="mt-8 max-w-3xl text-sm text-slate-600 italic border-l-4 border-teal pl-4 py-1"
        >
          The full Visibility Check<sup>™</sup> includes 25 questions across
          five dimensions.
        </p>
      </div>
    </section>
  );
}
